import { render, staticRenderFns } from "./ClinRecList.vue?vue&type=template&id=4f8ab6d5&"
import script from "./ClinRecList.vue?vue&type=script&lang=js&"
export * from "./ClinRecList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports